import StyledContainer from "style/styledContainer"
import styled from "styled-components"
import ticketBgImg from 'assets/images/ticket_bg.png'
import { Row, RowCenter } from "style/preset"
import { CommonSwitchBtnCom } from "components/SwitchBtnCom"

import { ReactComponent as AllTicketSvg } from 'assets/svgs/all_tickets.svg'
import { ReactComponent as DaoStakingSvg } from 'assets/svgs/dao_nav_staking.svg'
import { ReactComponent as DaoRewardsSvg } from 'assets/svgs/dao_nav_rewards.svg'
import { ReactComponent as DaoParticipateSvg } from 'assets/svgs/dao_nav_participate.svg'
import { useCallback, useEffect, useRef, useState } from "react"
import { ListBottomGradientWrap, ListTopGradientWrap, ScrollBoxWrap } from "components/Drawer/DrawerStyle"
import DashboardCom from "./components/DashboardCom"
import StakingCom from "./components/StakingCom"
import RewardsCom from "./components/RewardsCom"
import ParticipateCom from "./components/ParticipateCom"
import DrawerStakeCom from "components/Drawer/DrawerStakeCom"
import { useAppDispatch, useAppSelector } from "hooks/redux/hooks"
import { setOpenDaoStakWin } from "hooks/redux/slices/appSlice"
import { setWalletWinOpened } from "hooks/redux/slices/walletSlice"

const options = [
    {
        icon: AllTicketSvg,
        label: 'Dashboard'
    },
    {
        icon: DaoStakingSvg,
        label: 'Staking'
    },
    {
        icon: DaoRewardsSvg,
        label: 'Rewards'
    },
    {
        icon: DaoParticipateSvg,
        label: 'Participate'
    }
]

const DaoPage = () => {
    const [tabIndex, setTabIndex] = useState(0)
    const { openDaoStakWin } = useAppSelector((state) => state.app)
    const { isConnected } = useAppSelector((state) => state.wallet)
    const dispatch = useAppDispatch()

    useEffect(() => {
      setTabIndex(tabIndex)
    }, [tabIndex])

    const fnOpenDaoStakWin = useCallback(() => {
      if(isConnected) {
        dispatch(setOpenDaoStakWin(true))
      } else {
        dispatch(setWalletWinOpened(true))
      }
    }, [dispatch, isConnected])

    return <TicketsPageWrap>
        <EmptyColumn></EmptyColumn>
        <OutWrap>
            <TicketHeaderWrap>
                <StyledContainer $fontSize="22px" $lineHeight="22px" $fontWeight6 $roobertSemiBold>Chainge DAO</StyledContainer>
                <StyledContainer $mt="8px" $fontSize="14px" $lineHeight="18px" $fontWeight4 $roobertRegular $color="#767A7F">Decentralized governance empowering $vXCHNG holders for community-driven decisions</StyledContainer>
                <Row $justifyContent="space-between" $mt="20px">
                    <CommonSwitchBtnCom options={options} curIndex={tabIndex} onClick={(index) => setTabIndex(index)}></CommonSwitchBtnCom>
                    <AddNewBtnWrap onClick={fnOpenDaoStakWin}>
                        <DaoStakingSvgWrap></DaoStakingSvgWrap>
                        <AddNewBtnLabelWrap $roobertSemiBold>Stake now</AddNewBtnLabelWrap>
                    </AddNewBtnWrap>
                </Row>
            </TicketHeaderWrap>
            <TicketBodyWrap>
              <ListTopGradientWrap></ListTopGradientWrap>
              <ListBottomGradientWrap></ListBottomGradientWrap>
              <NewScrollBoxWrap>
                <StyledContainer $height="40px"></StyledContainer>
                { tabIndex === 0 && <DashboardCom onOpenStakeWin={fnOpenDaoStakWin} onOpenStaking={() => setTabIndex(1)}></DashboardCom> }
                { tabIndex === 1 && <StakingCom onOpenStakeWin={fnOpenDaoStakWin}></StakingCom> }
                { tabIndex === 2 && <RewardsCom></RewardsCom> }
                { tabIndex === 3 && <ParticipateCom></ParticipateCom> }
              </NewScrollBoxWrap>
            </TicketBodyWrap>
        </OutWrap>

        <DrawerStakeCom open={openDaoStakWin} closeChange={(isClosed) => dispatch(setOpenDaoStakWin(isClosed))}></DrawerStakeCom>
    </TicketsPageWrap>
}


const TicketsPageWrap = styled(StyledContainer)`
    display: flex;
    min-height: 100vh;
    flex: 1;
`

const EmptyColumn = styled(StyledContainer)`
  flex: 1;

  @media screen and (min-width: 1920px) {
    flex: 1;
  }
  @media screen and (min-width: 1440px) and (max-width: 1920px) {
    flex: 1;
  }
  @media screen and (min-width: 1024px) and (max-width: 1440px) {
    flex: 1;
  }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    flex: none;
    width: 24px;    
  }
  @media screen and (max-width: 768px) {
    flex: none;
  }
`

const OutWrap = styled(StyledContainer)`
  flex: 9;

  background-color: ${({theme}) => theme.basicWhite};
  background-image: url(${ticketBgImg});
  background-position: right top;
  background-repeat: no-repeat;
  background-size: 35vw;
  box-sizing: border-box;
  position: relative;
`

const TicketHeaderWrap = styled(StyledContainer)`
  padding: 30px 40px 20px 40px;
  border-bottom: 1px dashed #CACCCE;
`

const TicketBodyWrap = styled(StyledContainer)`
  height: calc(100vh - 180px);
  position: relative;
`

export const DaoStakingSvgWrap = styled(DaoStakingSvg)`
  width: 16px;
  height: 16px;
  rect, path {
    fill: #4D1DF7;
  }
`

export const AddNewBtnLabelWrap = styled(StyledContainer)`
  font-size:14px;
  line-height: 1;
  font-weight: 600;
  color: #4D1DF7;
  margin-left: 10px;
`

export const AddNewBtnWrap = styled(RowCenter)`
  border-radius: 6px;
  border: 1px solid #4D1DF7;
  padding: 10px 16px;
  cursor: pointer;

  &:hover {
    background-color: #4D1DF7;
    ${DaoStakingSvgWrap} {
      rect, path {
        fill: #ffffff;
      }
    }
    ${AddNewBtnLabelWrap} {
      color: #ffffff;
    }
  }
`

// order card
const NewScrollBoxWrap = styled(ScrollBoxWrap)`
  padding-left: 40px;
  padding-right: 40px;
`

export default DaoPage